module.exports = __webpack_public_path__ + "img/suspects2.ebe74e69.png";